<h1 mat-dialog-title>{{ title }} <br> <h4>Absorción Acida</h4></h1>
<hr>
<form id="form" autocomplete="off" [formGroup]="form" (ngSubmit)="enviar()">
    <mat-dialog-content>
        <div class="container-fluid">
            <div class="row">
                <!-- Características -->
                <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Características</mat-label>
                        <input matInput formControlName="caracteristicas" placeholder="Características"
                            (blur)="form.controls['caracteristicas'].markAsTouched()" uppercase alphanumericOnly maxlength="250">
                        <mat-error *ngIf="isValidField('caracteristicas')">
                            {{ getFieldError('caracteristicas') }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <!-- Realizo -->
                <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Realizo</mat-label>
                        <mat-select formControlName="realizo">
                            <mat-option value="ANTES DE LIMPIEZA">ANTES DE LIMPIEZA</mat-option>
                            <mat-option value="DESPUÉS DE LIMPIEZA">DESPUÉS DE LIMPIEZA</mat-option>
                        </mat-select>
                        <mat-error *ngIf="isValidField('realizo')">
                            {{ getFieldError('realizo') }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="text-right">
                <button mat-raised-button color="primary" class="m-1" type="submit">
                    <i class="fa fa-plus"></i> Guardar
                </button>
            </div>
        </div>
    </mat-dialog-content>
</form>

<!-- BOTÓN CERRAR -->
<div class="text-right mt-3 p-3">
    <button mat-raised-button color="warn" mat-dialog-close>
        <i class="fa fa-remove fa-solid"></i> Cerrar
    </button>
</div>
